import $ = require('jquery');
import {ListWidgetService} from "../service.listwidgets";
import { inspect } from 'util';
import {WebSocket} from "../websocket";
import { Utility} from '../utility';
export default class inspectionsByTypeController {
    static $inject = ["$scope", "$http", "ListWidgetService"];
    static AngularDependencies = ['$scope', '$http', 'ListWidgetService',inspectionsByTypeController];

    private oldDataInspectionType: any;
    private oldDataInspectionTotal: any;

    public levels = [];
    public months = [];
    public InspectionTypes: any[] = [];
    public InspectionTotals: any[] = [];
    public myOrder = ['level'];

    public inspectionTotalList = {
        "1-Full Inspection":[],
        "2-Walk-Around Driver / Vehicle":[],
        "3-Driver Only":[]
    }

    public inspectionType: any;
    public inspectionTotal: any;

    public flipOrder(sort: string) {
        if (sort == "count") {
            if (this.myOrder[0] == "count") {
                this.myOrder = ["-count"];
            }
            else if (this.myOrder[0] == "-count") {
                this.myOrder = ["count"];
            }
            else {
                this.myOrder = ["-count"];
            }
        }
        else if (sort == "level") {
            if (this.myOrder[0] == "level") {
                this.myOrder = ["-level"];
            }
            else if (this.myOrder[0] == "-level") {
                this.myOrder = ["level"];
            }
            else {
                this.myOrder = ["level"];
            }
        }
    }
    
    public AddtoTMCInspectionList(data) {
        this.inspectionType = data.InspectionType;
        this.InspectionTypes = [];

        for (let x = 0; x < this.inspectionType.length; x++) {
            var dateValue = new Date(this.inspectionType[x].ety_date);
            var finalDate = "(" +(dateValue.toLocaleDateString())+ ")";
            this.InspectionTypes.push({
                level: this.inspectionType[x].ety_descrip,
                count: this.inspectionType[x].ety_count,
                date: finalDate                
            });
        }
        this.oldDataInspectionType = data.InspectionType;
        this.ListWidgetService.updatecount("Inspections by Type", this.InspectionTypes.length);
    }
    
    public AddtoTMCInspectionTotalList(data) {
        this.inspectionTotal = data.InspectionTotal;
        this.InspectionTotals = [];
        this.inspectionTotal = this.inspectionTotal.slice(-36);
        
        
        this.inspectionTotalList = {
            "1-Full Inspection":[],
            "2-Walk-Around Driver / Vehicle":[],
            "3-Driver Only":[]
        };

        for (let x = 0; x < this.inspectionTotal.length; x++) {
            this.InspectionTotals.push({
                month: this.inspectionTotal[x].ety_month,
                count: this.inspectionTotal[x].ety_count,
                description: this.inspectionTotal[x].ety_descrip,
                level: this.inspectionTotal[x].ety_level,               
            });
            
            var monthArray = this.inspectionTotalList[this.InspectionTotals[x]["description"]];
            var monthName = this.InspectionTotals[x]["month"];
            var description = this.InspectionTotals[x]["description"];
            if(this.months.indexOf(monthName) == -1){
                this.months.push(monthName);
            }
            
            if(this.levels.indexOf(description) == -1){
                this.levels.push(description);
            }

            var countForMonth = this.InspectionTotals[x]["count"];
            monthArray.push(countForMonth);
            this.oldDataInspectionTotal = data.InspectionTotal;
        }       
    }

    constructor($scope: ng.IScope, $http: angular.IHttpService, public ListWidgetService: ListWidgetService) {
        let vm = this;

        WebSocket.OnUpdate(function(data) {
            if(!Utility.deepEqual(vm.oldDataInspectionType,data.InspectionType)){
                vm.AddtoTMCInspectionList(data);
                $scope.$digest();
                $scope.$broadcast("inspection_data_ready");
                $scope.$emit("list_changed");
            }
            if(!Utility.deepEqual(vm.oldDataInspectionTotal,data.InspectionTotal)){
                vm.AddtoTMCInspectionTotalList(data);
                $scope.$digest();
                $scope.$broadcast("inspection_data_ready");
                $scope.$emit("list_changed");
            }
        });

        var acc = document.getElementsByClassName("topbar");
        var i;
        for (i = 0; i < acc.length; i++) {
            var test = <any>acc[i]
            test.onclick = function() {
                this.classList.toggle("active");
                this.nextElementSibling.children[0].classList.toggle("hide");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/inspectionsbytype/controller.inspectionsbytype.ts